export type StatsigApp = 'clients' | 'sessions' | 'participant';

export type StatsigBookingType = 'moderated' | 'unmoderated' | 'ai_moderated' | 'survey';

/**
 * Every custom field a frontend sends. Services sends the study as `booking_id`, so a rule meant
 * for both sides needs a condition on each name.
 */
export type StatsigCustomFields = {
  app: StatsigApp;
  type?: string | null;
  team_id?: string | null;
  study_id?: string | null;
  booking_type?: StatsigBookingType | null;
  role?: string | null;
  demo?: boolean | null;
  hostname?: string | null;
};

export type StatsigFieldOverrides = Omit<Partial<StatsigCustomFields>, 'app'>;

export type StatsigUserShape = {
  userID: string;
  custom: Record<string, string | boolean>;
};

const isSet = (value: unknown): value is string | boolean => value !== undefined && value !== null && value !== '';

/**
 * Later layers win only with a set value, so a per-call field the caller couldn't resolve keeps the
 * bound one. `''` counts as unset; Statsig would otherwise store and compare it as a real value.
 */
export function buildStatsigUser(
  userID: string | null | undefined,
  ...layers: Array<Partial<StatsigCustomFields> | null | undefined>
): StatsigUserShape {
  const custom: Record<string, string | boolean> = {};
  for (const layer of layers) {
    for (const [field, value] of Object.entries(layer ?? {})) {
      if (isSet(value)) custom[field] = value;
    }
  }
  return { userID: userID || 'anonymous', custom };
}
